module.exports = __webpack_public_path__ + "static/media/search.e384fac9.svg";